import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import '../css/banner.css'
const bannercontent = document.querySelector(".bannercontent")
if (bannercontent) {
    new Swiper(bannercontent, {
        modules: [Pagination, Autoplay],
        speed: 800,
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
    });
}